export default __webpack_public_path__ + "static/media/login.516eae53.mp4";